import React, { useEffect } from 'react'; // Importera useEffect
import 'materialize-css/dist/css/materialize.min.css';
import 'material-icons/iconfont/material-icons.css'
import M from 'materialize-css'; // Importera M för att kunna använda M.Sidenav
import logo from '../img/Logo transparent clean.png'
import { Link } from 'react-router-dom';
// import CartContext from '../contexts/CartContext';
// import { useContext } from 'react';
// import { getCart } from '../apis/fourthwall';


export default function NavBar() {
  // const {cart, setCart} = useContext(CartContext)
  // useEffect körs efter att komponenten har renderats (liknande componentDidMount)
  useEffect(() => {
    // let savedCartID = localStorage.getItem('cart') ?? null;

    // Hitta sidenav-elementet med rätt ID
    let sidenav = document.querySelector("#mobile-demo");
    // Initiera Materialize Sidenav
    M.Sidenav.init(sidenav, {});

    // const loadCart = async () => {  
    //   const cart = await getCart(savedCartID)
    //   let newCart = []
    //   for (const item of cart.items) {
    //     newCart.push({...item.variant, quantity: item.quantity})
    //   }

    //   setCart(newCart)
    // }
    
    
    // loadCart()
    
  }, []); // Den tomma arrayen [] säkerställer att effekten bara körs en gång (efter första renderingen)

  





  return (
    <div>
      <nav className='blue-bg'>
        <div className="nav-wrapper blue-bg"> {/* Använd className istället för class i JSX */}
          <a href="#!" className="brand-logo"><img src={logo} alt='D1sabl3d logo' width={65}/></a> {/* Använd className */}
          {/* data-target ska matcha ID:t på din ul.sidenav */}
          <a href="#!" data-target="mobile-demo" className="sidenav-trigger right"><i className="material-icons">menu</i></a> {/* Använd className */}
            <ul className="right hide-on-med-and-down"> {/* Använd className */}
              <li><Link to="/">Home</Link></li>
          </ul>
          
        </div>
      </nav>

      {/* Se till att ID:t här matchar data-target i din a.sidenav-trigger och querySelector */}
      <ul className="sidenav" id="mobile-demo"> {/* Använd className */}
        <li><Link to="/">Home</Link></li>
      </ul>

      
    </div>
  );
}